import { render, staticRenderFns } from "./ExportRecordTable.vue?vue&type=template&id=8c021a10"
import script from "./ExportRecordTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportRecordTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports